module.exports = __webpack_public_path__ + "img/NEWS.0b3124d9.svg";